"use client"
import { useTranslations } from 'next-intl'
import NewsletterForm from '@/components/NewsletterForm'

export default function SocialFollow() {
  const t = useTranslations('ui')
  
  const socialLinks = [
    { 
      name: 'Facebook', 
      href: 'https://www.facebook.com/MSinTapujos',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      color: 'hover:bg-blue-600'
    },
    { 
      name: 'Twitter/X', 
      href: 'https://x.com/msintapujos',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      color: 'hover:bg-black'
    },
    { 
      name: 'YouTube', 
      href: 'https://www.youtube.com/@marcanosintapujos',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      color: 'hover:bg-red-600'
    },
    { 
      name: 'Instagram', 
      href: 'https://www.instagram.com/msintapujos/?hl=es',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
        </svg>
      ),
      color: 'hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600'
    },
    { 
      name: 'LinkedIn', 
      href: 'https://www.linkedin.com/in/marcano-sin-tapujos-26835895',
      icon: (
        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      color: 'hover:bg-blue-700'
    }
  ]
  
  return (
    <aside className="overflow-hidden rounded-xl bg-white shadow-sm">
      {/* Header avec gradient */}
      <div className="border-b bg-gradient-to-r from-purple-600 to-pink-600 p-4">
        <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-white">
          <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
            <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
            <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
          </svg>
          {t('followUs')}
        </h3>
      </div>
      
      {/* Icônes sociales */}
      <div className="p-4">
        <div className="grid grid-cols-3 gap-3">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Suivez-nous sur ${social.name}`}
              className={`group flex h-12 items-center justify-center rounded-lg bg-gray-100 text-gray-600 transition-all hover:text-white ${social.color}`}
            >
              {social.icon}
            </a>
          ))}
        </div>
        
        {/* Newsletter */}
        <div className="mt-4 rounded-lg bg-gray-50 p-3">
          <h4 className="mb-2 text-sm font-semibold text-gray-900">{t('newsletter')}</h4>
          <p className="mb-3 text-xs text-gray-600">
            {t('newsletterCta')}
          </p>
          <NewsletterForm 
            source="sidebar" 
            variant="compact"
            placeholder={t('newsletterPlaceholder')}
            buttonText={t('newsletterButton')}
          />
        </div>
        
        {/* Statistiques */}
        <div className="mt-4 grid grid-cols-2 gap-3 text-center">
          <div className="rounded-lg bg-gray-50 p-2">
            <p className="text-lg font-bold text-gray-900">27.3K</p>
            <p className="text-xs text-gray-600">{t('subscribers')}</p>
          </div>
          <div className="rounded-lg bg-gray-50 p-2">
            <p className="text-lg font-bold text-gray-900">1.3M</p>
            <p className="text-xs text-gray-600">{t('viewsPerMonth')}</p>
          </div>
        </div>
      </div>
    </aside>
  )
}